import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { ClerkProvider } from "@clerk/react";
import "./styles/global.css";
import App from "./App";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as
  string | undefined;

function ClerkWrapper({ children }: { children: React.ReactNode }) {
  if (!PUBLISHABLE_KEY) {
    console.warn(
      "[shelf] Missing VITE_CLERK_PUBLISHABLE_KEY — Clerk auth disabled. " +
        "Add it to your .env file to enable authentication.",
    );
    return <>{children}</>;
  }
  return (
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>{children}</ClerkProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClerkWrapper>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkWrapper>
  </StrictMode>,
);
